import React from 'react';
import RecordingQuestion from '../shared/RecordingQuestion';

const audioConfig = {
  screenRecord: false,
  audio: true,
  webCam: false,
  resolution: '1080',
  tabRecording: false,
  separateLayer: false,
  fromPopup: true,
  initiator: 'generic_embed',
};

const AudioRecordingQuestion = ({
  prompt,
  hippoPreviewBase,
  handleSave,
  questionId,
  currentUserId,
  setAnswer,
  resetAnswer,
  isPreviewing,
}) => (
  <RecordingQuestion
    questionId={questionId}
    recordingConfig={audioConfig}
    handleSave={handleSave}
    hippoPreviewBase={hippoPreviewBase}
    prompt={prompt}
    currentUserId={currentUserId}
    setAnswer={setAnswer}
    resetAnswer={resetAnswer}
    isPreviewing={isPreviewing}
  />
);

export default AudioRecordingQuestion;
